export default {
    BASE_URL: '/pms',
    api: [
        {
            name: 'list',
            desc: '项目设置列表',
            method: 'GET',
            path: '/list'
        },
        {
            name: 'select',
            desc: '项目列表下拉项',
            method: 'GET',
            path: '/list/select/box'
        },
        {
            name: 'status',
            desc: '项目状态',
            method: 'GET',
            path: 'status'
        },
        {
            name: 'insert',
            desc: '新增项目',
            method: 'POST',
            path: 'insert'
        },
        {
            name: 'delete',
            desc: '删除项目',
            method: 'DELETE',
            path: '/delete/{id}'
        },
        {
            name: 'updateStatus',
            desc: '编辑项目状态',
            method: 'PUT',
            path: 'edit/status'
        },
        {
            name: 'getMember',
            desc: '获取企业成员',
            method: 'GET',
            path: '/staff/list'
        },
        {
            name: 'getManager',
            desc: '获取管理人员',
            method: 'GET',
            path: '/station/list'
        },
        {
            name: 'getOtherRoles',
            desc: '获取其他角色',
            method: 'GET',
            path: '/other/list'
        },
        {
            name: 'detail',
            desc: '获取项目详情',
            method: 'GET',
            path: '/detail'
        },
        {
            name: 'update',
            desc: '编辑项目',
            method: 'PUT',
            path: '/update'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/project/setting.js